module.exports = __webpack_public_path__ + "static/prompt-questions-bb78d0b0d63b0235301f72678d14c18d.png";